const $inject = ['sectorService'];

const activeBookingService = function activeBookingService(sectorService) {
  let service = {};

  service.set = set;
  service.clear = clear;
  service.findFlightAddSeatSelection = findFlightAddSeatSelection;
  service.booking = undefined;
  service.isLoading = false;
  service.loadedPnr = null;
  service.checkForActionRequired = checkForActionRequired;
  service.checkHasPendingTickets = checkHasPendingTickets;

  function set(booking) {
    service.isLoading = false;
    if (service.booking) {
      service.booking.mbActive = false;
    }

    service.booking = booking;
    service.booking.currentStatus = sectorService.currentStatus(service.booking);
    service.booking.sectors = sectorService.reorder(service.booking);
    service.booking.abridge = sectorService.abridge(service.booking.sectors);
    service.booking.priceSummary = sectorService.priceSummary(
      service.booking.sectors,
      service.booking.currentBooking,
      service.booking.Configurations
    );

    let sectorsAreDefined = typeof service.booking.sectors !== 'undefined';
    service.booking.isDifferentCurrency = sectorsAreDefined
      ? service.booking.sectors.reduce(function (prev, sector) {
          return sector.BaseCurrency.Code == sector.CurrencyCode || prev;
        }, false)
      : false;

    service.booking.mbActive = true;
  }

  function clear() {
    service.booking = null;
    service.isLoading = false;
    service.loadedPnr = null;
  }

  function findFlightAddSeatSelection(activeBooking, activeFlight, seatNumber) {
    activeBooking.Flights.every((flight, index) => {
      if (flight.Identifier === activeFlight.Identifier) {
        activeBooking.Flights[index].Seat.SeatNumber = seatNumber;
        return false;
      }

      return true; // continue loop
    });
  }

  function checkForActionRequired() {
    var errorCodes = ['UC', 'HX', 'HL'];
    var hasActionRequired = false;
    var currentItinerary = service.currentItinerary;

    if (currentItinerary) {
      let allSectors = [].concat(
        currentItinerary.Air,
        currentItinerary.Cars,
        currentItinerary.Hotels,
        currentItinerary.Rail,
        currentItinerary.GroundTransports
      );
      var hasActionRequired = false;

      angular.forEach(allSectors, function (sector) {
        if (sector.BookingStatus && errorCodes.includes(sector.BookingStatus.Code)) {
          hasActionRequired = true;
        }
      });
    }
    if (
      service.booking &&
      service.booking &&
      service.booking.ValidationErrors &&
      service.booking.ValidationErrors.find((val) => val.SeverityType === 'Error')
    ) {
      hasActionRequired = true;
    }
    return hasActionRequired;
  }
  function checkHasPendingTickets() {
    var hasPendingTickets = false;
    var currentItinerary = service.currentItinerary;
    if (currentItinerary && currentItinerary.Air && currentItinerary.Air.length) {
      hasPendingTickets = currentItinerary.Air.some(
        (d) => !(d.BookingStatus && d.BookingStatus.Code === 'YK') && !(d.Tickets && d.Tickets.length > 0)
      );
    }
    return hasPendingTickets;
  }

  return service;
};

activeBookingService.$inject = $inject;

export default activeBookingService;



// WEBPACK FOOTER //
// ./src/services/activeBookingService.js